import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import JsxHelper from '../Helpers/JsxHelper';
import React from 'react';
import RoleService from '../Services/roleService';
import FeeTypesEnum from '../Enums/FeeTypesEnum';

export default class FreelancerUserIgnoredSurveyItem {
  constructor(item) {
    if (item) {
      this.FreelancerUserIgnoreSurveyId = item.freelancerUserIgnoreSurveyId;
      this.FreelancerUserId = item.freelancerUserId;
      this.ClientId = item.clientId;
      this.ClientName = `${item.clientName} (${item.clientId})`;
      this.SurveyId = item.surveyId;
      this.SurveyName = item.surveyId ? `${item.surveyName} (${item.surveyId})` : '';
      this.TpSurveyId = item.tpSurveyId;
      this.TpSurveyName = item.tpSurveyId ? `${item.tpSurveyName} (${item.tpSurveyId})` : '';
      this.ThirdPartySource = item.thirdPartySource;
      this.FeeType = item.feeType;
      this.IsActive = item.isActive;
      this.ModifiedOn = item.modifiedOn;
      this.ModifiedBy = item.modifiedBy;
      return;
    }
    this.FreelancerUserIgnoreSurveyId = '';
    this.FreelancerUserId = '';
    this.ClientId = '';
    this.ClientName = '';
    this.SurveyId = '';
    this.SurveyName = '';
    this.TpSurveyId = '';
    this.TpSurveyName = '';
    this.ThirdPartySource = '';
    this.FeeType = '';
    this.IsActive = '';
    this.ModifiedOn = '';
    this.ModifiedBy = '';
  }

  static DateFields = ['ModifiedOn'];

  static FieldsToShowInListTable = [];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Client (ID)',
        orderById: 'ClientId',
        data: 'ClientName',
        type: FieldTypesEnum.PureDataField,
        minWidth: 140,
      },
      {
        label: 'Survey (ID)',
        orderById: 'SurveyId',
        data: 'SurveyName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'TP Survey (ID)',
        orderById: 'TpSurveyId',
        data: 'TpSurveyName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Third Party Source',
        orderById: 'ThirdPartySource',
        data: 'ThirdPartySource',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Fee Type',
        orderById: 'FeeType',
        data: 'FeeType',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Modified On',
        orderById: 'ModifiedOn',
        data: 'ModifiedOn',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Modified By',
        orderById: 'ModifiedBy',
        data: 'ModifiedBy',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Is Active?',
        orderById: 'IsActive',
        data: (item) => JsxHelper.YesNo(item.IsActive),
        type: FieldTypesEnum.PureDataField,
      },
      { label: ' ', data: FreelancerUserIgnoredSurveyItem.getDetailCellContent, type: FieldTypesEnum.ActionButton },
    ];
  }

  static getDetailCellContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: item.IsActive ? 'fa-solid fa-toggle-off' : 'fa-solid fa-toggle-on',
            onClick: () => FreelancerUserIgnoredSurveyItem.ChangeIsActiveStatus(item),
            text: item.IsActive ? 'Disable' : 'Enable',
            disabled: FreelancerUserIgnoredSurveyItem.IsDisabled(item),
          },
        ]}
      />
    );
  }

  static IsDisabled(item) {
    return (
      (item.FeeType == FeeTypesEnum.RM && !RoleService.CheckUserPermission('faicon', 'isactive_rm_ignoredsurvey')) ||
      (item.FeeType == FeeTypesEnum.DQ && !RoleService.CheckUserPermission('faicon', 'isactive_dq_ignoredsurvey'))
    );
  }

  static ChangeIsActiveStatus(item) {
    alert('This function is not implemented yet.');
  }
}
